import React from 'react';
import Layout from '../components/Layout';
import { Link } from 'react-router-dom';

export default function TermsConditions() {
  return (
    <Layout>
      <div className="page-banner">
        <h1>Terms &amp; Conditions</h1>
      </div>
      <div className="main-content">
        <div className="policy-content">
          <h2>Terms &amp; Conditions</h2>
          <p className="updated">Last Updated: May 21, 2026</p>

          <p>By using Smart Device Assistant, you agree to the following terms:</p>

          <ol>
            <li>
              <strong>Use of Content:</strong><br />
              Our website provides general informational content. Users may view and use content for personal,
              non-commercial purposes only.
            </li>
            <li>
              <strong>Disclaimer of Liability:</strong><br />
              We are not responsible for any errors or omissions in our content. Use of our information is at your
              own risk.
            </li>
            <li>
              <strong>External Links:</strong><br />
              Our website may contain links to external websites. We do not control and are not responsible for the
              content or practices of these sites.
            </li>
            <li>
              <strong>Personal Information Submitted:</strong><br />
              Any personal information you provide through contact forms, chat features, or other communications is
              handled according to our <Link to="/privacypolicy">Privacy Policy</Link>. By submitting information,
              you consent to our collection and use as described in the Privacy Policy.
            </li>
            <li>
              <strong>User Conduct:</strong><br />
              Users may not engage in illegal activities, spam, or unauthorized access to our site.
            </li>
            <li>
              <strong>Intellectual Property:</strong><br />
              All content on this site is owned by Smart Device Assistant and protected by copyright laws.
            </li>
            <li>
              <strong>Termination:</strong><br />
              We reserve the right to restrict access for users who violate these terms.
            </li>
            <li>
              <strong>Governing Law:</strong><br />
              These terms are governed by U.S. law.
            </li>
          </ol>
        </div>
      </div>
    </Layout>
  );
}
